import { maskitoNumberOptionsGenerator } from '@maskito/kit';

/**
 * Base Maskito number params shared by inputs and display formatting.
 */
export const LASER_TREATMENT_CONTROL_MASKS_PARAMS = {
  serviceTime: {
    min: 0,
    maximumFractionDigits: 0,
    thousandSeparator: ',',
  },
  smartCool: {
    min: 0,
    maximumFractionDigits: 0,
    thousandSeparator: ',',
  },
  joules: {
    min: 0,
    maximumFractionDigits: 3,
    minimumFractionDigits: 3,
    thousandSeparator: ',',
  },
  pulse: {
    min: 0,
    maximumFractionDigits: 3,
    minimumFractionDigits: 3,
    thousandSeparator: ',',
  },
  repRate: {
    min: 0,
    maximumFractionDigits: 3,
    minimumFractionDigits: 3,
    thousandSeparator: ',',
  },
} as const;

/**
 * Maskito options generated from the shared params for form controls.
 */
export const LASER_TREATMENT_CONTROL_MASKS = {
  serviceTime: maskitoNumberOptionsGenerator(LASER_TREATMENT_CONTROL_MASKS_PARAMS.serviceTime),
  smartCool: maskitoNumberOptionsGenerator(LASER_TREATMENT_CONTROL_MASKS_PARAMS.smartCool),
  joules: maskitoNumberOptionsGenerator(LASER_TREATMENT_CONTROL_MASKS_PARAMS.joules),
  pulse: maskitoNumberOptionsGenerator(LASER_TREATMENT_CONTROL_MASKS_PARAMS.pulse),
  repRate: maskitoNumberOptionsGenerator(LASER_TREATMENT_CONTROL_MASKS_PARAMS.repRate),
} as const;
